export default "__VITE_ASSET__B_$9NMmi__"